import { useQuery } from '@tanstack/react-query';

import { programsApi } from '../api/programsApi';
import { SimpleProgramParams } from '../types/simpleProgram';

export const useProgram = (programId?: number) => {
  const { data: program, isLoading } = useQuery({
    queryKey: ['program', programId],
    queryFn: () =>
      programId
        ? programsApi.fetchProgram({ id: programId })
        : Promise.resolve(null),
    enabled: !!programId,
    refetchOnWindowFocus: false,
  });

  return {
    program,
    isLoading,
  };
};

export const useProgramList = (params: SimpleProgramParams) => {
  const { data: programsPagination, isLoading } = useQuery({
    queryKey: ['program-list', params],
    queryFn: () => programsApi.fetchProgramList(params),
    refetchOnWindowFocus: false,
  });

  return {
    programs: programsPagination?.data,
    totalCount: programsPagination?.total,
    isLoading,
  };
};
